import React, { useState, useRef, useEffect } from "react";
import classes from "./SellableVsNonSellable.module.css";
import Button from "../UIResuableComponents/Button";
import { FaRegCalendarAlt } from "react-icons/fa";
import { MdKeyboardArrowDown, MdOutlineCancel } from "react-icons/md";
import Input from "../UIResuableComponents/CreateForm/Input";
function SellableVsNonSellable(props) {
  useEffect(() => {
    onChangehandler();
  }, []);
  const circlebarRef = useRef();
  const [fromToDate, setFromToDate] = useState({
    from: "",
    to: "",
  });
  const [dateToggle, setDateToggle] = useState(false);
  const onInputChangeHandler = (name, value) => {
    const newData = { ...fromToDate };
    newData[name] = value;
    setFromToDate(newData);
  };
  const onClickDateToggle = (e, type) => {
    e.preventDefault();

    setDateToggle(type);
  };

  const onChangehandler = (e) => {
    // var val = parseInt(e.target.value);
    var sellable = 10;
    var nosellable = 7;
    var total = sellable + nosellable;
    var per = (sellable / total) * 100;
    var circle = circlebarRef.current;
    circle.style.strokeDashoffset = 133 + 4.32 * (100 - per);

    document
      .querySelector("#cont")
      .setAttribute("data-pct", `${parseInt(per)}% sellable`);
  };

  return (
    <div className={` ${props.customCss} bg-bgwhite rounded w-full py-5 px-2`}>
      <div className="flex flex-col lg:flex-row justify-between items-center  w-full border-b-[1px] border-bglightgrey p-2 text-center sm:text-left  ">
        <div className=" w-full mr-6 ">
          <h3 className="text-[0.6rem] font-medium">
            Sellable vs Non Sellable
          </h3>
        </div>
        <div className="mr-4">
          <Button
            onClickHandler={props.openComparePopUpToggle}
            btnName="Compare"
            btnStyle={`bg-btnbgcolor text-bgwhite !py-1 !px-2 !text-xs font-bold `}
          />
        </div>
        <div className="relative cursor-pointer text-btnbgcolor text-[0.5rem] report-date-shadow rounded">
          <div
            onClick={(e) => onClickDateToggle(e, true)}
            className="flex justify-center items-center py-1 px-2"
          >
            <span className="mr-2">
              <FaRegCalendarAlt />
            </span>
            <span>19.12.2020-</span>
            <span>03.12.2021</span>
            <span className="text-base">
              <MdKeyboardArrowDown />
            </span>
          </div>
          {dateToggle && (
            <div className="absolute top-[130%] p-3 bg-bgdarkgrey rounded z-10">
              <div
                onClick={(e) => onClickDateToggle(e, false)}
                className="absolute top-[3%] right-[5%] text-base"
              >
                <MdOutlineCancel />
              </div>
              <Input
                valueLabel={"from"}
                onInputChangeHandler={onInputChangeHandler}
                type={"text"}
                Name={"From"}
                value={fromToDate.from}
                inputStyle={"!py-[0.1rem]"}
                labelStyle={"!text-xs"}
                isRequired={false}
              />
              <Input
                valueLabel={"to"}
                onInputChangeHandler={onInputChangeHandler}
                type={"text"}
                Name={"To"}
                value={fromToDate.to}
                inputStyle={"!py-[0.1rem]"}
                labelStyle={"!text-xs"}
                isRequired={false}
              />
            </div>
          )}
        </div>
      </div>
      <div id="cont" className={classes.cont} data-pct="100% sellable">
        <svg
          id="svg"
          className={classes.svg}
          width="200"
          height="200"
          viewport="0 0 100 100"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            r="70"
            cx="100"
            cy="100"
            fill="transparent"
            strokeDasharray="565.48 "
            strokeDashoffset="0"
          ></circle>
          <circle
            ref={circlebarRef}
            id="bar"
            className={classes.bar}
            r="70"
            cx="100"
            cy="100"
            fill="transparent"
            strokeDasharray="565.48"
            strokeDashoffset="0"
          ></circle>
        </svg>
      </div>
      <div className="flex justify-center my-4">
        <div className="bg-bgdarkgrey py-4 px-4 flex flex-col items-center w-[40%] rounded">
          <span className="font-bold">8</span>
          <span className="text-xs">Sellable</span>
        </div>
        <div className="bg-lightpink py-4 px-4 flex flex-col items-center w-[40%] ml-2 rounded">
          <span className="font-bold">7</span>
          <span className="text-xs">Non Sellable</span>
        </div>
      </div>
      {/* <input onChange={onChangehandler} id="percent" name="percent"></input> */}
    </div>
  );
}

export default SellableVsNonSellable;
